<template>
	<div class="detail-container">
		<div class="detail-header">
			<div class="detail-header-title">
				<span>
					<span class="header-title"> {{ detail.title }}</span>
				</span>
			</div>
			<div class="detail-header-user flex ai_c">
				<img :src=detail.user.avatar :alt=detail.user.username v-if="detail.user && detail.user.avatar"/>
				<img :alt=detail.user.username src="data:image/png;base64,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" v-else/>
				{{ detail.user && detail.user.username }}
			</div>
		</div>
		<div class="detail-body">
			<div class="detail-content">
				<div v-html="detail.content" class="content"></div>
				<!-- 话题内容 -->
				<detail-comment :data=detail :showDelete="detail.currentId == detail.user.userId" :reply="false"
					:detailReply="true" @backList=backList @commitComment=commitComment @page=getDetail @complain=complain>
				</detail-comment>
				<!-- 话题内容结束 -->
			</div>
			<div class="detail-comment">
				<div class="comment-header flex ai_c">
					<span class="flex ai_c comments">
						评论<span>( {{ detail.comments }} 条评论 )</span>
					</span>
					<span class="items" :class="{ active: sortBy == 'heat' }" @click="sortBy = 'heat'">按热度</span>
					<span class="items" :class="{ active: sortBy == 'time' }" @click="sortBy = 'time'">按发布时间</span>
					<!-- <span>共{{detail.comments}}条回复</span> -->
				</div>
				<!-- 话题评论 -->
				<comment-unit v-for="(item, index) in comments" :data=item :key="'unit_' + index" :id=id :currentId=currentId
					@refresh=getComments @complain=complain>
				</comment-unit>
				<!-- 话题评论 -->
			</div>
			<p class="list-loading" v-if="loading"><i class="el-icon-loading"></i></p>
			<p v-else @click="showMoreClick">{{ bottomText }}</p>
		</div>
		<el-dialog :visible.sync="complaintVisible" title="投诉" width="902px" @opened=openDialog>
			<el-form label-width="60px">
				<el-form-item label="类型">
					<el-radio-group v-model="complaint.type">
						<el-radio :label="1">违法信息</el-radio>
						<el-radio :label="2">广告</el-radio>
						<el-radio :label="3">人身攻击</el-radio>
						<el-radio :label="4">不实信息</el-radio>
						<el-radio :label="5">其他</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="内容">
					<div ref="toolbar" class="editor-toolbar" v-show="false" />
					<div ref="editor" class="editor"></div>
				</el-form-item>
			</el-form>
			<div class="flex jc_e ai_c pt8">
				<t-btn @click="complaintVisible = false" w="78px" h="36px" fs="12px" type="info mr16"
					class="pointer bold">取消</t-btn>
				<t-btn @click="complaintCommit" w="78px" h="36px" fs="12px" class="pointer bold">提交</t-btn>
			</div>
		</el-dialog>

	</div>
</template>

<script>
import message from '@/mixins/message'
import DetailComment from './components/detail-comment.vue';
import CommentUnit from './components/comment-unit.vue';
import E from 'wangeditor'
export default {
	inject: ["headerRefresh"],
	name: "bussiness",
	mixins: [message],
	components: {
		DetailComment,
		CommentUnit
	},
	data() {
		return {
			sortBy: "heat",         //评论排序
			complaintVisible: false,       //投诉弹窗
			complainId: "",            //投诉评论的ID
			comments: [],
			loading: false,
			showNumber: 10,
			complaint: {
				type: 1
			},
			page: {                    //分页数据
				page: 1,
				perPage: 10,
				totalCount: 0
			},
			detail: {
				user: {
					userId: "",
				},
			},
			currentId: "",//评论列表当前ID,判断评论是否本人发表
			id: ""
		}
	},
	created() {
		this.init()
	},
	computed: {
		bottomText() {
			const { page: { totalCount } } = this;
			if (totalCount <= 10) {
				return ""
			} else {
				return this.comments.length < totalCount ? "显示更多" : "这里是底线，没有更多了"
			}
		}
	},
	watch: {
		sortBy() {
			this.comments = [];
			this.getComments();
		},
		showNumber(val) {
			this.page.page = this.showNumber / this.page.perPage;
			this.getComments();
		},
		'$route'() {
			if (this.$route.params.id) {
				this.init()
			}
		}
	},
	methods: {
		init() {
			const { id } = this.$route.params
			this.id = id
			this.getDetail();
			this.getComments();
		},
		backList() {
			this.$router.replace({
				name: 'forum'
			})
		},
		showMoreClick() {
			if (this.showNumber < this.page.totalCount) {
				this.showNumber += 10;
			}
		},
		getDetail() {
			const { id } = this
			this.$api.forum.detail({ id }).then(data => {
				this.detail = data;
			})
		},
		getComments(emptyList) {
			if (emptyList) this.comments = [];
			const { id, page, sortBy, keyWord: keyword } = this
			this.loading = true;
			this.$api.forum.comments({
				...page, id, sortBy
			}).then(data => {
				this.loading = false;
				this.currentId = data.currentId;
				if (page.page == 1) {
					this.comments = data.items;
				} else {
					this.comments = this.comments.concat(data.items);
				}
				this.page = data.page;
			})
		},
		complain(id) {
			if (id) this.complainId = id;
			this.complaintVisible = true;
		},

		/**
		 * @description 话题评论
		 * @return void
		 */
		commitComment(data) {
			const { id } = this;
			const { comment: content } = data;
			this.comments = [];
			this.$api.forum.comment({
				id, content,
				action: "add"
			}).then(res => {
				this.getComments()
			})
		},

		/**
		 * @description 提交投诉
		 * @return void
		 */
		complaintCommit() {
			const { complaint: { type } } = this;
			const remark = this.editor.txt.text();
			let { complainId: id } = this;
			if (!id) id = this.id;
			//console.log(complaint)
			console.log({ complainId: id })
			console.log(id)
			console.log(this.detail.id)
			if (id == this.detail.id) {
				this.$api.coop.complaint({
					type,
					remark,
					id,
					source: 1
				}).then(() => {
					this.success({
						message: '投诉成功!'
					})
				})
				this.complaintVisible = false;
				this.complaint = {
					type: 1,
				}
				this.complainId = ""
				this.editor.txt.clear()
			}else{
				this.$api.coop.complaint({
					type,
					remark,
					id:id,

					commentId:this.detail.id,
					source: 1
				}).then(() => {
					this.success({
						message: '投诉成功!'
					})
				})
				this.complaintVisible = false;
				this.complaint = {
					type: 1,
				}
				this.complainId = ""
				this.editor.txt.clear()
			}

		},

		openDialog() {
			const $e = this.$refs.editor;
			const $tool = this.$refs.toolbar;
			const editor = new E($tool, $e) // 工具栏和编辑器分开
			editor.config.showMenuTooltips = false;
			editor.config.height = 200;
			editor.config.placeholder = '请输入投诉信息'
			editor.create()
			this.editor = editor;
		}
	}
}
</script>

<style lang="scss" scoped>
.detail-container {
	height: 100%;
	background: #fff;
	padding: 24px;
	border-radius: 16px;

	overflow-y: scroll;

	&::-webkit-scrollbar {
		width: 0;
	}

	.detail-header {
		font-size: 18px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #333333;
		line-height: 25px;

		.detail-header-user {
			padding: 12px 0;
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #333333;

			img {
				width: 28px;
				height: 28px;
				border-radius: 50%;
				margin-right: 8px;
			}
		}
	}

	.detail-body {
		padding: 0;

		.content {
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;					
			font-weight: 400;
			color: #333333;
			line-height: 1.8;
			word-break: break-all;
			text-align: justify;
		}

		.detail-comment {
			margin-top: 16px;
			padding: 16px 0;
			border-top: 1px solid #f4f6f8;

			.comment-header {
				.comments {
					font-size: 18px;
					font-family: PingFang-SC-Heavy, PingFang-SC;
					font-weight: 800;
					color: #383D41;
					line-height: 25px;
					margin-right: 16px;

					span {
						color: #60707D;
						font-size: 14px;
						font-weight: 400;
					}
				}

				.items {
					margin-right: 6px;
					min-width: 78px;
					height: 32px;
					line-height: 32px;
					text-align: center;
					background: rgba(195, 207, 217, 0.2);
					border-radius: 8px;
					display: inline-block;
					font-size: 14px;
					padding: 0 10px;
					cursor: pointer;

					&.active {
						color: #056BFD;
						background: rgba(5, 107, 253, 0.1);
					}
				}
			}
		}

		.list-loading {
			text-align: center;
			font-size: 30px;
		}

		p {
			text-align: center;
			cursor: pointer;
		}
	}
}

.editor {
	border-radius: 4px;
	border: 1px solid #D0D0D0;
	height: 175px;

	/deep/ .el-form-item__label {
		padding: 0 24px 0 0;
	}

	/deep/ .editor-container {
		border-radius: 4px;
		border: 1px solid #D0D0D0;
		overflow: hidden;

		.editor-toolbar {
			border-radius: 0;
			border: none;
		}

		.editor-content {
			border-radius: 0;
			border: none;
			height: 260px;
			font-size: 14px;
			color: #60707D;
		}
	}
}
</style>